import { render, staticRenderFns } from "./view-serial-photo.vue?vue&type=template&id=54d33c7c&scoped=true&"
import script from "./view-serial-photo.vue?vue&type=script&lang=js&"
export * from "./view-serial-photo.vue?vue&type=script&lang=js&"
import style0 from "./view-serial-photo.vue?vue&type=style&index=0&id=54d33c7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d33c7c",
  null
  
)

export default component.exports